import { z } from 'zod';
import { ArtifactSchema } from '../artifact.js';
import { AgentRenderableArtifactSchema } from './conversation.js';

export const AgentSavedDashboardItemSchema = z
  .object({
    id: z.string().uuid(),
    title: z.string(),
    artifact: AgentRenderableArtifactSchema,
    sourceConversationId: z.string().uuid().nullable(),
    sourceMessageId: z.string().uuid().nullable(),
    position: z.number().int().nonnegative(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
  })
  .strict();

export const AgentSavedDashboardItemsResponseSchema = z
  .object({
    items: z.array(AgentSavedDashboardItemSchema),
  })
  .strict();

export const CreateAgentSavedDashboardItemInputSchema = z
  .object({
    artifact: ArtifactSchema,
    title: z.string().trim().min(1).max(200).optional(),
    sourceConversationId: z.string().uuid().nullable().optional(),
    sourceMessageId: z.string().uuid().nullable().optional(),
  })
  .strict();

export const ReorderAgentSavedDashboardItemsInputSchema = z
  .object({
    items: z
      .array(
        z
          .object({
            id: z.string().uuid(),
            position: z.number().int().nonnegative(),
          })
          .strict(),
      )
      .max(200),
  })
  .strict();

export type AgentSavedDashboardItem = z.infer<typeof AgentSavedDashboardItemSchema>;
export type AgentSavedDashboardItemsResponse = z.infer<
  typeof AgentSavedDashboardItemsResponseSchema
>;
export type CreateAgentSavedDashboardItemInput = z.infer<
  typeof CreateAgentSavedDashboardItemInputSchema
>;
export type ReorderAgentSavedDashboardItemsInput = z.infer<
  typeof ReorderAgentSavedDashboardItemsInputSchema
>;
